import { CLIP } from '../../../enums';
import { CommentDrawingFilter, isVisibleComment, matchesCommentDrawingFilter } from '../../../helpers/comments';

export type CommentClip = CLIP & { rowIndex: number; clipIndex: number; topicName: string };
export const clipLabel = (clip: CommentClip) => `${String(clip.rowIndex + 1).padStart(2, '0')} ${clip.topicName}, clip ${clip.clipIndex + 1}`;
export const containsPlayhead = (clip: CLIP, seconds: number) => seconds >= clip.time_start && seconds < clip.time_end;

export const commentCandidates = (clips: CommentClip[], selectedIds: Set<string>, seconds: number) =>
  clips.filter((clip) => containsPlayhead(clip, seconds) && (!selectedIds.size || selectedIds.has(String(clip.id))));

export const visibleCommentClips = (clips: CommentClip[], selectedIds: Set<string>,
  nowPlaying: boolean, drawingFilter: CommentDrawingFilter, playingId?: string, revealedId?: string) => {
  const scoped = clips.filter((clip) => String(clip.id) === revealedId || (selectedIds.size
    ? nowPlaying ? String(clip.id) === playingId : selectedIds.has(String(clip.id))
    : clip.comments.some(isVisibleComment)));
  return scoped.filter((clip) => selectedIds.has(String(clip.id)) || String(clip.id) === revealedId ||
    (selectedIds.size > 0 && nowPlaying && String(clip.id) === playingId) ||
    clip.comments.some((comment) => matchesCommentDrawingFilter(comment, drawingFilter)));
};
